<template>
  <div class="headers">
    <div class="PC" v-if="facilityHead">
      <el-row class="header_box">
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" :push="3">
          <router-link to="/">
            <img src="@/assets/home/logo.png" class="logo" alt="logo" />
          </router-link>
        </el-col>
        <el-col
          :xs="2"
          :sm="2"
          :md="2"
          :lg="2"
          :xl="2"
          v-for="(item, index) in navigation"
          :key="index"
          class="navigation"
          :push="2"
          :class="navigationIndex == index ? ' navigation_index' : ''"
        >
          <span style="display: block" @click="handleNavigation(item, index)">{{
            item.title
          }}</span>
          <div class="navigation_info">
            <div class="navigation_box">
              <div class="kailong" v-if="item.child"></div>
              <span
                @click="handleNavChild(item, val)"
                v-for="(val, i) in item.child"
                :key="i"
                >{{ val.name }}</span
              >
            </div>
          </div>
        </el-col>
      </el-row>

      <div style="position: relative">
        <el-carousel
          :height="navigationIndex !== 0 ? '7.64rem' : '100vh'"
          :autoplay="navigationIndex ? false : true"
          :indicator-position="navigationIndex ? 'none' : ''"
        >
          <el-carousel-item
            v-for="(item, index) in navigationIndex
              ? bannerImg.slice(0, 1)
              : bannerImg"
            :key="index"
          >
            <el-row class="home_banner_info" v-if="navigationIndex == 0">
              <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
                <div class="left_info">监测</div>
                <div class="right_info">
                  <p class="title_en">{{ item.english }}</p>
                  <div class="title">{{ item.title }}</div>
                  <div class="title_child">
                    <div v-for="(val, i) in item.child" :key="i">{{ val }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="banner_bg">
              <div></div>
              <img
                :src="
                  navigationIndex
                    ? getImgUrl(bannerImg[navigationIndex - 1])
                    : getImgUrl(item.path)
                "
                alt="banner图"
                width="100%"
              />
            </div>
          </el-carousel-item>
        </el-carousel>

        <el-row class="menus_box" v-if="menusList">
          <el-col
            :xs="18"
            :sm="18"
            :md="18"
            :lg="18"
            :xl="18"
            :offset="3"
            class="menu_box"
          >
            <div
              v-for="(item, index) in menusList"
              :key="index"
              class="iocn_box"
              @click="handleNavChild(item)"
              :class="iocnBoxIndex == item.name ? 'iocn_box_index' : ''"
            >
              <i :class="'iconfont' + ' ' + item.icon"></i>
              <span>{{ item.name }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row class="about_banner_info" v-if="navigationIndex == 5">
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
            <div class="phone_box">
              <p class="name">联系电话</p>
              <p class="phone">400-000-7168</p>
              <p class="time">(工作日:8 : 30-17 : 30)</p>
            </div>
            <div class="address">
              <p class="info">武汉市洪山区文化大道融创智谷 A7 栋 8 号楼</p>
              <div class="contact">
                <p class="zh">联系我们</p>
                <p class="eg">Contact us</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="mobile" v-else>
      <div class="top_box">
        <router-link to="/">
          <img class="logo" src="@/assets/logo_m.png" alt="logo" />
        </router-link>
        <div class="right_box">
          <img class="search_m" src="@/assets/home/search_m.png" alt="搜索" />
          <img
            class="navigation_m"
            src="@/assets/home/navigation_m.png"
            alt="导航"
            @click="show = true"
          />
        </div>
      </div>
      <van-popup
        v-model="show"
        :overlay-style="{ background: 'rgba(0,0,0,.3)' }"
        position="right"
        :style="{ height: '100%', background: 'rgba(0,0,0,.7)' }"
      >
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item
            v-for="(item, index) in navigation"
            :key="index"
            :is-link="item.child ? true : false"
          >
            <template slot="title">
              <span class="title-box" @click="handleNavigation(item, index)">{{
                item.title
              }}</span>
            </template>
            <template slot="default">
              <p
                @click="handleNavChild(item, val)"
                v-for="(val, i) in item.child"
                :key="i"
              >
                {{ val.name }}
              </p>
            </template>
          </van-collapse-item>
        </van-collapse>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Popup, Collapse, CollapseItem } from 'vant'
import homeData from '@/static/data.json'
import Vue from 'vue'
Vue.use(Popup)
  .use(Collapse)
  .use(CollapseItem)

export default {
  name: 'headers',
  data() {
    return {
      navigation: [], // 导航栏
      iocnBoxIndex: '',
      bannerImg: [], // banner
      show: false,
      activeNames: '1'
    }
  },

  created() {
    let nav = sessionStorage.getItem('navigation')
    window.addEventListener('setItem', e => {
      nav = JSON.parse(e.newValue)
      this.iocnBoxIndex = nav.child ? nav.child.name : ''
    })
    nav = JSON.parse(nav)
    if (nav && nav.child) this.iocnBoxIndex = nav.child.name
    else this.iocnBoxIndex = ''

    this.navigation = homeData.data.navigation
    this.bannerImg = this.navigationIndex
      ? homeData.data.bannerNav
      : homeData.data.banner

    let path = this.$router.history.current.path
    this.navigation.forEach((item, i) => {
      if (path.includes(item.path)) {
        // url路径
        let navigation = {
          title: item.title,
          index: i,
          child: { name: this.iocnBoxIndex }
        }
        if (!this.iocnBoxIndex) this.$delete(navigation, 'child')
        this.resetSetItem('navigation', JSON.stringify(navigation))
      }
    })
  },

  props: ['menusList', 'facilityHead', 'navigationIndex'],

  methods: {
    // PC 导航切换
    handleNavigation(item, i) {
      this.$router.push(this.navigation[i].path)
      let navigation = {
        title: item.title,
        index: i
      }
      if (i === 2) this.$set(navigation, 'child', { name: '地质灾害' })
      if (i === 4) this.$set(navigation, 'child', { name: '全部' })
      this.resetSetItem('navigation', JSON.stringify(navigation))
    },

    // PC 二级导航
    handleNavChild(item, val) {
      let navigation
      if (val) {
        if (val.name === 'QimMoS') {
          window.location.href = 'https://qimmos.cn'
        } else if (val.name === 'QimConst') {
          window.location.href = 'http://qimconst.cn'
        } else {
          this.navigation.forEach((el, i) => {
            if (el.title === item.title) {
              this.$router.push(el.path)
              navigation = {
                title: item.title,
                index: i,
                child: {
                  name: val.name
                }
              }
              this.resetSetItem('navigation', JSON.stringify(navigation))
            }
          })
          this.iocnBoxIndex = val.name
        }
      } else {
        this.iocnBoxIndex = item.name
        let nav = JSON.parse(sessionStorage.getItem('navigation'))
        navigation = {
          title: nav.title,
          index: nav.index,
          child: {
            name: item.name
          }
        }
        this.resetSetItem('navigation', JSON.stringify(navigation))
      }
    },

    getImgUrl(src) {
      return require('@/assets/home/' + src)
    }
  }
}
</script>

<style lang="scss" scoped>
.headers {
  .PC {
    .header_box {
      width: 100%;
      line-height: 0.96rem;
      background-color: rgba($color: #000000, $alpha: 0.1);
      position: absolute;
      z-index: 30;
      font-size: 0.247rem;
      font-weight: 500;
      color: #cbecff;
      .logo {
        width: 1.87rem;
        height: 0.53rem;
        position: relative;
        top: 0.2rem;
      }
      .navigation {
        text-align: center;
        position: relative;
        .navigation_info {
          width: 100%;
          color: #1966b2;
          font-size: 0.186rem;
          position: absolute;
          display: none;
          .navigation_box {
            margin-top: 0.2rem;
            background-color: rgba($color: #fff, $alpha: 0.5);
            border-radius: 0.05rem;
            .kailong {
              width: 0;
              height: 0;
              border-right: 0.15rem solid transparent;
              border-left: 0.15rem solid transparent;
              border-bottom: 0.15rem solid rgba($color: #fff, $alpha: 0.5);
              position: absolute;
              top: 0.05rem;
              left: 50%;
              transform: translateX(-50%);
            }
          }
          span {
            display: block;
            line-height: 0.6rem;
          }
          span:hover {
            background-color: rgba($color: #fff, $alpha: 0.17);
            color: #fff;
          }
        }
      }
      .navigation_index {
        background-color: rgba($color: #fff, $alpha: 0.17);
      }
      .navigation:hover {
        background-color: rgba($color: #fff, $alpha: 0.17);
        cursor: pointer;
        .navigation_info {
          width: 2.4rem;
          position: absolute;
          left: -0.4rem;
          display: block;
        }
      }
    }
    /deep/ .el-carousel__indicators--horizontal {
      bottom: 0.1rem;
    }
    .carousel_bg {
      position: absolute;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100vh;
      background: rgba($color: #000000, $alpha: 0.5);
    }
    .menus_box {
      position: absolute;
      bottom: 0;
      z-index: 10;
      width: 100%;
      .menu_box {
        box-shadow: 0.05rem 0.09rem 0.15rem 1px rgba(140, 140, 140, 0.65);
        background-color: #fff;
        display: flex;
        box-sizing: border-box;
        height: 2.08rem;
        .iocn_box {
          width: 20%;
          text-align: center;
          margin: 0.5rem 0;
          cursor: pointer;
          color: #4b4b4b;
          i {
            font-size: 0.515rem;
          }
          span {
            display: block;
            line-height: 0.5rem;
            font-size: 0.186rem;
            font-weight: bold;
            margin-top: 0.1rem;
          }
        }
        .iocn_box_index {
          color: #1a5db3;
        }
      }
    }
    .home_banner_info {
      position: absolute;
      padding-top: 2.82rem;
      z-index: 10;
      width: 100%;
      height: 100vh;
      color: #fff;
      // background: rgba($color: #000000, $alpha: 0.2);
      .el-col {
        display: flex;
        justify-content: flex-end;
        .left_info {
          margin: auto 0.6rem -0.2rem 0;
          font-size: 0.876rem;
          font-family: SimSun;
        }
        .right_info {
          position: relative;
          .title_en {
            font-size: 0.25rem;
          }
          .title {
            font-size: 0.876rem;
            font-weight: bold;
            border-bottom: 0.05rem #fff solid;
            display: inline-block;
            padding-bottom: 0.15rem;
            margin-bottom: 0.2rem;
          }
          .title_child {
            position: absolute;
            right: 0;
            width: 3.4rem;
            display: flex;
            flex-wrap: wrap;
            div {
              width: 1.65rem;
              background-color: #fff;
              margin-bottom: 0.1rem;
              color: #5289f4;
              text-align: center;
              font-weight: bold;
              line-height: 0.3rem;
              border-radius: 0.05rem 0.05rem;
              font-size: 0.144rem;
            }
            div:nth-child(2n) {
              margin-left: 0.06rem;
            }
          }
        }
      }
    }
    .banner_bg {
      height: 100%;
      overflow: hidden;
      position: relative;
      div {
        position: absolute;
        top: 0;
        z-index: 5;
        width: 100%;
        height: 100%;
        background: rgba($color: #000000, $alpha: 0.2);
      }
    }
    .about_banner_info {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      width: 100%;
      color: #fff;
      .phone_box {
        text-align: left;
        font-weight: 400;
        .name {
          font-size: 0.247rem;
        }
        .phone {
          color: #bfbfbf;
          font-size: 0.36rem;
          margin: 0.25rem 0;
        }
        .time {
          font-size: 0.206rem;
        }
      }
      .address {
        font-size: 0.247rem;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        .info {
          margin-top: 3rem;
          color: #bfbfbf;
        }
        .contact {
          font-weight: 400;
          margin-top: 1.3rem;
          .zh {
            font-size: 0.825rem;
          }
          .eg {
            font-size: 1.01rem;
            text-transform: uppercase;
          }
        }
      }
    }
  }
  .mobile {
    .top_box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .logo {
        margin: 0.06rem 0 0.21rem 0;
        width: 1.57rem;
        height: 0.45rem;
      }
      .right_box {
        .search_m {
          margin-top: 0.09rem;
          width: 0.17rem;
          height: 0.17rem;
        }
        .navigation_m {
          width: 0.19rem;
          height: 0.15rem;
          margin-left: 0.2rem;
        }
      }
    }
    /deep/ .van-popup {
      .van-collapse {
        width: 3.15rem;
        box-sizing: border-box;
        .van-collapse-item {
          .van-cell {
            background: none;
            color: #fff;
            font-size: 0.12rem;
          }
          .van-collapse-item__content {
            background: rgba($color: #fff, $alpha: 0.24);
            color: #fff;
            font-size: 0.09rem;
            padding: 0 0 0 0.4rem;
          }
          .van-cell::after {
            border-bottom: none;
          }
          .van-cell__title {
            margin-left: 0.2rem;
          }
          .van-cell__right-icon {
            margin-right: 0.2rem;
          }
          p {
            padding: 0.1rem 0;
            box-sizing: border-box;
          }
        }
        .van-collapse-item--border::after {
          border-top: none;
        }
      }
      .van-hairline--top-bottom::after,
      .van-hairline-unset--top-bottom::after {
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue